/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Campaign } from '../models/Deployservicev3Campaign';
import { HttpFile } from '../http/http';

export class Deployservicev3ListCampaignsResponse {
    /**
    * the campaigns found in the current page.
    */
    'campaigns'?: Array<Deployservicev3Campaign>;
    /**
    * the page token to send to retrieve the next page of results.
    */
    'nextPageToken'?: string;
    /**
    * the total number of results without regard to page .
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "campaigns",
            "baseName": "campaigns",
            "type": "Array<Deployservicev3Campaign>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return Deployservicev3ListCampaignsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

